<template>
    <v-container fill-height class="align-start">
        <div class="body-cont2 profile">
            <div class="col-md-12 col-xs-12 no-pad page-titel">
                <h2>
                    Profiles
                </h2>
            </div>
            <div class="col-md-10 col-md-offset-1 col-sm-12 col-xs-12 text-right search">
                <div class="ser-wrap">
                    <input id="search" name="search" type="text" placeholder="Search a profile">
                    <i class="fa fa-search hidden-xs" onclick="openSearchBar()"></i>
                </div>

            </div>
            <div v-if="!profileNotFound || loading.length > 0" class="col-md-offset-1 col-md-10 col-xs-12 profile-cont profile">
                <div class="valign">

                    <div class="col-md-5 col-xs-12 no-padding">
                        <img class="hidden-xs profilePic user-profiles" alt="" :src="getAvatarLink(profile)">
                    </div>
                    <div class="col-md-7 col-xs-12 text-center">
                        <h2 class="rate">{{ profile.firstname }} {{ profile.lastname }} ({{ profile.id }})</h2>
                        <img class="hidden-lg hidden-md hidden-sm mobile" alt="" :src="getAvatarLink(profile)">

                        <span class="hidden-xs comment">{{ comments.length }} comments</span>
                        <ul class="rate">
                            <li class="hidden-lg hidden-md hidden-sm"><span>{{ comments.length}} comments</span></li>
                            <li v-if="$route.params.matchId"><a @click.prevent="openCommentModal">Post Comment</a></li>
                            <li>
                                <div class="star-rating">
                                    <input id="star-5" type="radio" name="rating" value="star-5">
                                    <label class="star" for="star-5" title="5 stars">
                                        <i class="active fa fa-star" :class="{'star-inactive': userRating.rating < 5}" aria-hidden="true"></i>
                                    </label>
                                    <input class="star" id="star-4" type="radio" name="rating" value="star-4">
                                    <label for="star-4" title="4 stars">
                                        <i class="active fa fa-star" aria-hidden="true" :class="{'star-inactive': userRating.rating < 4}"></i>
                                    </label>
                                    <input class="star" id="star-3" type="radio" name="rating" value="star-3">
                                    <label for="star-3" title="3 stars">
                                        <i class="active fa fa-star" aria-hidden="true" :class="{'star-inactive': userRating.rating < 3}"></i>
                                    </label>
                                    <input class="star" id="star-2" type="radio" name="rating" value="star-2">
                                    <label for="star-2" title="2 stars">
                                        <i class="active fa fa-star" aria-hidden="true" :class="{'star-inactive': userRating.rating < 2}"></i>
                                    </label>
                                    <input class="star" id="star-1" type="radio" name="rating" value="star-1">
                                    <label for="star-1" title="1 star">
                                        <i class="active fa fa-star" aria-hidden="true" :class="{'star-inactive': userRating.rating < 1}"></i>
                                    </label>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-if="profileHasComments" class="valign comment">
                    <div class="carousel slide" data-ride="carousel" id="myCarousel">
                        <div class="carousel-inner">
                            <div class="item" v-for="(comment, index) in comments" :key="comment.id" :class="{ 'active' : index === 0 }">
                                <div class="col-md-6 col-sm-12">
                                    <div class="thumb-img">
                                        <img v-if="comment.commenting_user.avatar" alt="" :src="comment.commenting_user.avatar" class="avatar-small">
                                        <h2 class="share">{{ comment.commenting_user.firstname }} {{ comment.commenting_user.lastname }} ({{ comment.user_id }}) <span class="time visible-xs"><i
                                            class="fa fa-clock-o" aria-hidden="true"></i>{{ comment.commented_at | moment("MMM Do YYYY, HH:mm") }}</span></h2>
                                        <ul class="hidden-xs">
                                            <li>
                                                <i class="fa fa-clock-o" aria-hidden="true"></i>
                                                {{ comment.commented_at | moment("MMM Do YYYY, HH:mm") }}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                    <div class="decp">
                                        <div class="item">
                                            <p>{{ comment.comment }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <div v-if="profileNotFound" class="col-md-offset-1 col-md-10 col-xs-12 profile-cont profile">
                <div>Profile not found</div>
            </div>


            <div class="col-md-offset-1 col-md-10 col-xs-12">
                <div class="col-md-6 col-xs-6 page-nav">
                    <a class="left carousel-control" data-slide="prev" href="#myCarousel"><i
                        class="fa fa-angle-left"></i>BACK </a>
                </div>
                <div class="col-md-6 col-xs-6 page-nav text-right">
                    <a class="right carousel-control" data-slide="next" href="#myCarousel"> NEXT <i
                        class="fa fa-angle-right"></i></a>
                </div>
            </div>
        </div>
        <div class="modal fade offer rate" id="comment-modal" tabindex="-1" role="dialog" aria-labelledby="rateModal"
             aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <textarea autofocus v-model="comment" name="comment" form="usrform" placeholder="Type your comment here."></textarea>
                    </div>
                    <div class="modal-footer">
                        <button type="button" data-toggle="modal" @click="postComment"
                                class="btn btn-primary save">POST
                        </button>
                        <button type="button" class="btn btn-secondary cancel" @click="closeCommentModal">Cancel</button>
                    </div>
                </div>
                <div id="swal-container-post-comment-modal"></div>
            </div>
            <loading-overlay :loading="loading.length > 0"></loading-overlay>
        </div>

        <loading-overlay :loading="loading.length > 0"></loading-overlay>
        <div id="swal2-container"></div>
    </v-container>
</template>

<script>
    export default {
        name: "user-profiles",
        mounted: mounted,
        data: data,
        computed: getComputed(),
        methods: getMethods(),
    }

    function data(){
        return {
            profile: {},
            comments: {},
            loading: [],
            comment: '',
            userRating: {}

        }
    }

    function mounted(){
        const vm = this;
        setupUiElements();
        const profileId = vm.$route.params.id || vm.$store.state.user.id;
        getProfile();
        getUserComments();

        function getProfile(){
            getUser();
            getUserRating();

            function getUser(){
                vm.loading.push('loading profile');
                Vue.backendApi().user(profileId).getUser().then(success, error);
                function success(response){
                    vm.loading = vm.loading.filter((element) => {
                        return element !== 'loading profile';
                    });
                    vm.profile = response.data;
                }

                function error(error){
                    vm.loading = vm.loading.filter((element) => {
                        return element !== 'loading profile';
                    });
                    vm.$swal({
                        type: 'error',
                        title: 'Error loading profile',
                        text: error
                    });
                }
            }

            function getUserRating(){
                vm.loading.push('loading user rating');
                Vue.backendApi().user(profileId).getUserRating().then(success, error);
                function success(response){
                    vm.loading = vm.loading.filter((element) => {
                        return element !== 'loading user rating';
                    });
                    vm.userRating = response.data;
                }

                function error(error){
                    vm.loading = vm.loading.filter((element) => {
                        return element !== 'loading user rating';
                    });
                    vm.$swal({
                        type: 'error',
                        title: 'Error loading user rating',
                        text: error
                    });
                }
            }
        }

        function getUserComments(){
            vm.loading.push('loading comments');
            Vue.backendApi().user(profileId).getUserComments().then(success, error);
            function success(response){
                vm.loading = vm.loading.filter((element) => {
                    return element !== 'loading comments';
                });
                vm.comments = response.data;
            }

            function error(error){
                vm.loading = vm.loading.filter((element) => {
                    return element !== 'loading comments';
                });
                vm.$swal({
                    type: 'error',
                    title: 'Error loading comments',
                    text: error
                });
            }
        }

        function setupUiElements(){
            vm.$store.commit('pageHeaderClass', '');
            vm.$store.commit('pageHeaderTitle', 'Profiles');
            vm.$store.commit('mobileMenuIsVisible', true);
            vm.$store.commit('closeButtonIsVisible', false);
            vm.$store.commit('hideLogoPart', false);
            window.dispatchEvent(new Event('positionBottomButton'));
        }
    }

    function getComputed(){
        return {
            profileNotFound: profileNotFound,
            profileHasComments: profileHasComments
        }

        function profileNotFound(){
            return Object.keys(this.profile).length === 0;
        }

        function profileHasComments(){
            return Object.keys(this.comments).length > 0;
        }
    }

    function getMethods() {
        return {
            getAvatarLink: getAvatarLink,
            openCommentModal: openCommentModal,
            closeCommentModal: closeCommentModal,
            postComment: postComment
        }
        function getAvatarLink(user){
            if (! user.avatar){
                return '/images/default-avatar.png';
            } else {
                return user.avatar;
            }
        }

        function openCommentModal(){
            $('#comment-modal').modal('show');
            //this.$emit('accept');
        }

        function closeCommentModal(){
            $('#comment-modal').modal('hide');
            //this.$emit('cancel');
        }

        function postComment(){
            const vm = this;
            vm.loading.push('saving comments');
            // SPINNER
            const payload = {
                user_id: vm.$route.params.id,
                commenter_id: vm.$store.state.user.id,
                comment: vm.comment
            };
            Vue.backendApi().postComment(vm.$route.params.matchId, payload).then(success, error);

            function success(response){
                vm.loading = vm.loading.filter((element) => {
                    return element !== 'saving comments';
                });
                vm.$swal({
                    type: 'success',
                    title: 'Comment saved',
                    text: 'Your comment has been saved.',
                    target: document.getElementById('swal-container-post-comment-modal'),
                    preConfirm: () => {
                        $('#comment-modal').modal('hide');
                    }
                });
            }

            function error(error){
                vm.loading = vm.loading.filter((element) => {
                    return element !== 'saving comments';
                });
                vm.$swal({
                    type: 'error',
                    title: 'Error posting comments',
                    text: error,
                    target: document.getElementById('swal-container-post-comment-modal'),
                });
            }
        }


    }
</script>

<style scoped>

    .body-cont2 .profile-cont .valign ul li i.fa.fa-star.star-inactive {
        color: rgb(187, 187, 187);
    }

    .avatar-small {
        max-width: 76px;
        max-height: 76px;
    }
</style>
